const menuSettings = `
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
      <g fill="none" fill-rule="evenodd" transform="matrix(-1 0 0 1 18 0)">
        <path stroke="#F5F5F5" stroke-linejoin="round" d="M16.0785,8.814 C17.61225,7.2795 17.9085,4.9725 16.971,3.14025 L14.487,5.616 L12.489,5.616 L12.489,3.51 L14.91075,1.026 C13.07925,0.08925 10.7475,0.3855 9.21375,1.9185 C7.68075,3.4515 7.36875,5.75175 8.30625,7.584 L0.936,14.94825 C0.35025,15.53325 0.34575,16.48275 0.93225,17.0685 C1.518,17.655 2.46525,17.655 3.05175,17.0685 L10.41375,9.70575 C12.246,10.6425 14.54625,10.34625 16.0785,8.814 Z"/>
        <rect width="18" height="18"/>
      </g>
    </svg>

`;

export default menuSettings;
